import { Link } from "react-router-dom";
import { ArrowRight, Users, Network, Handshake } from "lucide-react";
import { Reveal } from "@/components/Reveal";

const PATHS = [
    { icon: Users, label: "Direct Partner" },
    { icon: Network, label: "City Franchise Partner" },
    { icon: Handshake, label: "Sub-Partner" },
];

export const PartnerTeaser = () => (
    <section id="partner" data-testid="partner-teaser-section" className="relative overflow-hidden bg-omsivo-navy py-20 lg:py-28">
        <span aria-hidden className="text-outline-light pointer-events-none absolute -top-8 right-0 select-none font-display text-[14vw] font-black leading-none opacity-[0.05]">
            PARTNER
        </span>
        <div className="relative z-10 mx-auto max-w-[1440px] px-4 sm:px-6 lg:px-10">
            <div className="grid grid-cols-1 items-center gap-10 lg:grid-cols-12">
                <div className="lg:col-span-7">
                    <Reveal>
                        <p className="font-mono text-[11px] font-semibold uppercase tracking-[0.28em] text-flame">Partner With Us</p>
                    </Reveal>
                    <Reveal delay={0.08}>
                        <h2 className="mt-4 font-display text-3xl font-extrabold uppercase leading-[1.05] tracking-tight text-white sm:text-4xl lg:text-5xl">
                            Build your business.<br />Build with <span className="text-flame">OMSIVO.</span>
                        </h2>
                    </Reveal>
                    <Reveal delay={0.14}>
                        <p className="mt-5 max-w-xl text-base leading-relaxed text-white/65">
                            A performance-based partnership ecosystem — local network development, customer relationships and project opportunities with OMSIVO central support.
                        </p>
                    </Reveal>
                </div>
                <div className="lg:col-span-5">
                    <div className="space-y-3">
                        {PATHS.map((p, i) => (
                            <Reveal key={p.label} delay={0.06 * i}>
                                <div className="flex items-center gap-4 rounded-2xl border border-white/10 bg-white/[0.04] px-5 py-4 backdrop-blur-sm" data-testid={`partner-teaser-path-${i}`}>
                                    <p.icon className="h-5 w-5 shrink-0 text-flame" />
                                    <span className="font-display text-sm font-bold uppercase tracking-[0.08em] text-white/90">{p.label}</span>
                                    <span className="ml-auto font-mono text-[10px] text-white/30">0{i + 1}</span>
                                </div>
                            </Reveal>
                        ))}
                    </div>
                    <Reveal delay={0.2}>
                        <Link to="/partner" data-testid="partner-teaser-cta"
                            className="group mt-6 inline-flex items-center gap-3 rounded-full bg-flame px-7 py-3.5 font-display text-sm font-bold uppercase tracking-[0.1em] text-white transition-all hover:-translate-y-0.5 hover:bg-flame-dark">
                            Explore Partnership
                            <ArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-1" />
                        </Link>
                    </Reveal>
                </div>
            </div>
        </div>
    </section>
);
